import {Routes} from '@angular/router';
import {OktaCallbackComponent} from '@components/okta-callback/okta-callback.component';
import {UnsavedChangesFilter} from '@shared/filter/unsaved-changes.filter';
import {ErrorComponent} from '../app/core/error/error.component';
import {ThemeInitGuard} from '../app/core/guards/theme-init.guard';

export const routes: Routes = [
  {path: '', redirectTo: '/login/', pathMatch: 'full'},

  // --- Error route (standalone error page) ---
  {path: 'error', component: ErrorComponent},

  // --- All brand-scoped routes guarded by ThemeInitGuard ---
  {
    path: 'home',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'ordering',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/ordering/ordering.component').then(m => m.OrderingComponent),
  },
  {
    path: 'ordering-details',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/ordering-details/ordering-details.component').then(m => m.OrderingDetailsComponent),
    canDeactivate: [UnsavedChangesFilter]
  },
  {
    path: 'patients',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/patients/patients.component').then(m => m.PatientsComponent),
  },
  {
    path: 'preferences',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/preferences/preferences.component').then(m => m.PreferencesComponent),
    canDeactivate: [UnsavedChangesFilter]
  },
  {
    path: 'bypass-patient-creation',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/bypassed-patient-creation/bypassed-patient-creation.component')
        .then(m => m.BypassedPatientCreationComponent),
    canDeactivate: [UnsavedChangesFilter]
  },
  {
    path: 'other',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/other/other.component').then(m => m.OtherComponent),
  },
  {
    path: 'calendar',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/calendar/calendar.component').then(m => m.CalendarComponent),
  },
  {
    path: 'wholesale-dashboard',
    canActivate: [ThemeInitGuard],
    loadComponent: () =>
      import('./components/wholesale-dashboard/wholesale-dashboard.component')
        .then(m => m.WholesaleDashboardComponent),
  },

  {path: 'callback', component: OktaCallbackComponent},

  {
    path: 'landing',
    loadComponent: () =>
      import('./components/landing/landing/landing.component').then(m => m.LandingComponent),
  },
];
